<div
  class="history-container"
  data-testid="chat-history"
  (click)="$event.stopPropagation()"
  (keydown)="$event.stopPropagation()"
  tabindex="-1"
>
  <div class="history-header">Open chat session</div>

  @if (loading) {
    <div class="loading-spinner" data-testid="chat-history-loading">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  }

  @if (error) {
    <div class="error-message" data-testid="chat-history-error" [attr.data-error-kind]="errorKind" role="alert">
      <mat-icon color="warn">error</mat-icon>
      <span>{{ error }}</span>
      <button mat-button type="button" data-testid="chat-history-retry" (click)="loadSessions()">Retry</button>
    </div>
  }

  @if (!loading && !error && sessions.length === 0) {
    <div class="empty-state" data-testid="chat-history-empty">
      <p>No past conversations found.</p>
    </div>
  }

  @if (!loading && sessions.length > 0) {
    <div class="session-list">
      @for (session of sessions; track session) {
        <div
          (click)="selectSession(session)"
          (keydown.enter)="selectSession(session)"
          (keydown.space)="selectSession(session); $event.preventDefault()"
          class="session-item"
          data-testid="chat-history-session"
          [attr.data-session-id]="session.sessionId"
          [attr.data-session-title]="session.title || 'Untitled chat'"
          [attr.data-session-model]="session.modelName"
          [attr.data-project-id]="session.projectId || ''"
          [attr.data-message-count]="session.messageCount || 0"
          [attr.data-active]="isActiveSession(session)"
          [class.active-session]="isActiveSession(session)"
          tabindex="0"
          role="button"
        >
          <mat-icon class="chat-icon">{{ isActiveSession(session) ? 'chat' : 'chat_bubble_outline' }}</mat-icon>
          <div class="session-info">
            <div class="session-title">
              {{ session.title || 'Untitled chat' }}
              @if (isActiveSession(session)) {
                <span class="active-badge">Active</span>
              }
            </div>
            <div class="session-subtitle">
              Created {{ session.createdAt | date: 'short' }} · {{ session.messageCount || 0 }} message{{
                (session.messageCount || 0) !== 1 ? 's' : ''
              }}
            </div>
          </div>
          <button
            mat-icon-button
            (click)="deleteSession($event, session)"
            matTooltip="Delete chat"
            [attr.aria-label]="'Delete chat ' + (session.title || 'Untitled chat')"
            class="delete-button"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      }
    </div>
  }
</div>
